// extracted by mini-css-extract-plugin
module.exports = {"content":"layout-module--content--2CPz1","main_content":"layout-module--main_content--3oed6"};